/* ============================================================
   JilbabCo — Seasonal Suitability Widget JS  (prefix: jcs-)
   ============================================================ */
(function () {
  'use strict';

  var overlay = document.getElementById('jcs-overlay');
  if (!overlay) return;

  var openBtns = document.querySelectorAll('[data-jcs-open]');
  var closeBtns = overlay.querySelectorAll('[data-jcs-close]');

  function open() {
    overlay.classList.add('jcs-overlay--open');
    document.body.style.overflow = 'hidden';
    // Focus close button for a11y
    var closeBtn = overlay.querySelector('[data-jcs-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    overlay.classList.remove('jcs-overlay--open');
    document.body.style.overflow = '';
  }

  // Open
  openBtns.forEach(function (btn) {
    btn.addEventListener('click', open);
  });

  // Close buttons
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  // Close on backdrop click
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('jcs-overlay--open')) {
      close();
    }
  });
})();
